


















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosVeiculo extends Vue {

    get placa () {
        return this.$store.state.placa;
    }

    get marca () {
        return this.$store.state.placa.marca;
    }

    get modelo () {
        return this.$store.state.placa.modelo;
    }

    get ano () {
        return this.$store.state.placa.ano;
    }

    get combustivel () {
        return this.$store.state.placa.combustivel;
    }

    get valor_fipe () {
        return this.$store.state.placa.valor_fipe;
    }

    public getLogoMarca ( value: string ) {
        try {
            return require("@/assets/marcas/" + value + ".svg");
        } catch (e) {
            return require("@/assets/marcas/Desconhecida.svg");
        }
    }
}
